import { css, FlattenSimpleInterpolation } from "styled-components";
import { createStyleObject } from "@capsizecss/core";
import notoSansJpMetrics from "@capsizecss/metrics/notoSansJP";
import montserratMetrics from "@capsizecss/metrics/montserrat";

interface Props {
	fontSize: number;
	lineHeight: number;
	font?: "notosansjp" | "montserrat" | null;
}
const trimLeading = ({ fontSize, lineHeight, font}: Props): FlattenSimpleInterpolation =>
	css(
		createStyleObject({
			fontSize: fontSize,
			leading: lineHeight,
			fontMetrics:
				font == "montserrat"
					? montserratMetrics
					: Object.assign(notoSansJpMetrics, {
							capHeight: 990,
							descent: -200,
					  }),
		})
	);

export default trimLeading;
